"use client";

import { SearchSpringContext } from "@/components/SearchSpring/SearchSpringContext/SearchSpringContextProvider";
import { getFacetIdentifier, getFacetParams } from "@/lib/searchspring/utils";
import { FC, useContext, useMemo } from "react";
import CheckboxInput from "../../UI/Input/Checkbox/Checkbox";
import styles from "./Facet.module.scss";

export interface FacetProps {
	field: string;
	facet: {
		filtered: boolean;
		value?: string;
		label: string;
		count: number;
		high?: number;
		low?: number;
	};
}

const Facet: FC<FacetProps> = ({
	field,
	facet: { filtered, value, high, low, label, count },
}) => {
	const { facetsToApply, handleAddFacet } = useContext(SearchSpringContext);

	if (filtered) return null;

	const facetId = getFacetIdentifier({
		field,
		value,
		high,
		low,
	});

	const onClickEvent = () => {
		const toApply = {
			params: getFacetParams({
				field,
				value,
				high,
				low,
			}),
			count,
		};

		handleAddFacet(toApply);
	};

	return (
		<div className={styles.facet}>
			<CheckboxInput
				aria-label={label}
				label={
					<span>
						{label} <span className={styles.count}>({count})</span>
					</span>
				}
				checked={facetsToApply.some(
					(facet) => facet.params.join("") === facetId,
				)}
				role='checkbox'
				onClick={onClickEvent}
			/>
		</div>
	);
};

export default Facet;
